import { useQuery, gql } from '@apollo/client'
import { Box } from '@chakra-ui/react'
import { LeaderboardLayout } from '../componentsF/LeaderboardLayoutAI.jsx'
import { VotingTable } from '../componentsF/VotingTableAI.jsx'
import { useLocalStorage } from '../../componentsF/localStorageF/LocalStorWrapF.tsx'
import { buildVotesMap } from '../componentsF/donaHelpersAI.jsx'

const entriesQuery = gql`
  query($limit: Int, $offset: Int) {
    gqDonaEntries(limit: $limit, offset: $offset, kind: label) {
      id
      donaRef
      supportOppose
      amountUsd
    }
  }
`

const myDonationsQuery = gql`
  query($senderAddr: String!) {
    gqMyDonations(senderAddr: $senderAddr) {
      entryId
      donaRef
      supportOppose
      contributedUsd
    }
  }
`

const HomePage = () => {
  const {data, loading, error} = useQuery(entriesQuery, {variables: {limit: 50, offset: 0}})
  const [walletAddr] = useLocalStorage('donaWalletAddr')
  const {data: myData} = useQuery(myDonationsQuery, {variables: {senderAddr: walletAddr || ''}, skip: !walletAddr})

  if (error) return <Box p={8} color="red.500">Error: {error.message}</Box>

  const entries = data?.gqDonaEntries ?? []
  const myVotes = buildVotesMap(myData?.gqMyDonations ?? [])

  // Transform entries for VotingTable
  const tableEntries = entries.map((entry) => ({
    id: entry.id,
    donaRef: entry.donaRef,
    displayName: entry.donaRef,
    amountUsd: parseFloat(entry.amountUsd),
  }))

  return (
    <LeaderboardLayout
      title="String Leaderboard"
      subtitle="Buy your spot on the leaderboard. Highest payers get top entries!"
      categoryKind="label"
      currentPath="/"
      loading={loading}
    >
      <VotingTable
        entries={tableEntries}
        myVotes={walletAddr ? myVotes : null}
      />
    </LeaderboardLayout>
  )
}

export default HomePage
